import { LOAD_TIME_RATE_SYSTEM_FAIL, LOAD_TIME_RATE_SYSTEM_REQUEST, LOAD_TIME_RATE_SYSTEM_SUCCESS } from 'src/store/actions/timeRateAssociationsActions';
const initialState = {
    fetching: false,
    list: [],
    types: []
};
const toTypes = (arr) => arr.map(({ Id }) => Id);
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case LOAD_TIME_RATE_SYSTEM_REQUEST: {
            return { ...state, fetching: true };
        }
        case LOAD_TIME_RATE_SYSTEM_FAIL: {
            return { ...state, fetching: false };
        }
        case LOAD_TIME_RATE_SYSTEM_SUCCESS: {
            return {
                ...state, fetching: false, list: payload, types: toTypes(payload)
            };
        }
        default: {
            return state;
        }
    }
};
